var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAreasIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 22.666L17.3332 19.9993V13.1433C19.6278 12.5473 21.3332 10.4767 21.3332 7.99935C21.3332 5.05802 18.9412 2.66602 15.9998 2.66602C13.0585 2.66602 10.6665 5.05802 10.6665 7.99935C10.6665 10.4767 12.3718 12.5473 14.6665 13.1433V19.9993L15.9998 22.666ZM13.3332 7.99935C13.3332 6.52868 14.5292 5.33268 15.9998 5.33268C17.4705 5.33268 18.6665 6.52868 18.6665 7.99935C18.6665 9.47002 17.4705 10.666 15.9998 10.666C14.5292 10.666 13.3332 9.47002 13.3332 7.99935Z",
    fill: "#90A4AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6892 14.0834L20.9785 16.654C24.4332 17.6087 26.6665 19.4447 26.6665 21.3327C26.6665 23.8554 22.2865 26.666 15.9998 26.666C9.71317 26.666 5.33317 23.8554 5.33317 21.3327C5.33317 19.4447 7.5665 17.6087 11.0225 16.6527L10.3118 14.082C5.59584 15.386 2.6665 18.1634 2.6665 21.3327C2.6665 25.818 8.52384 29.3327 15.9998 29.3327C23.4758 29.3327 29.3332 25.818 29.3332 21.3327C29.3332 18.1634 26.4038 15.386 21.6892 14.0834Z",
    fill: "#90A4AE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreasIcon);
export default __webpack_public_path__ + "static/media/areasIcon.da11dedecff5fd8c87910f957d7233fb.svg";
export { ForwardRef as ReactComponent };